module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.responsible_originators,
      "placeholder": "Select Commercial Originator",
      "item-value": "userid",
      "item-text": "fullName",
      "solo": "",
      "outline": ""
    },
    model: {
      value: (_vm.responsible_originator),
      callback: function($$v) {
        _vm.responsible_originator = $$v
      },
      expression: "responsible_originator"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder",
    staticStyle: {
      "margin-top": "0px !important"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncSaveKam.apply(null, arguments)
      }
    }
  }, [_vm._v("Save Responsible Originator")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)
},staticRenderFns: []}